<template>
  <el-col>
    <div class="footer_wrapper">
      <img class="img_logo" src="@/src/assets/img/img_logo.png" alt="">
      <p class="txt_copyright">COPYRIGHT ©2023 ALL RIGHTS RESERVED.</p>
    </div>
  </el-col>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.footer_wrapper {
  padding: 4rem;
  height: auto;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .txt_copyright {
    font-size: 0.5rem;
    color: black;
  }

  .img_logo {
    height: 2rem;
    margin-bottom: 1rem;
  }
}
</style>
